import SEO from '@cannect/components/SEO'
import { useBrand } from 'hooks/useBrand'
import BaseRecipe from 'pages/BaseRecipe'
import 'styles/aspaec-theme.css'
import 'styles/remederi-theme.css'
import 'styles/vikura-theme.css'

/**
 * Versão whitelabel da página de receita (mesmo conteúdo do BaseRecipe,
 * com o tema da marca). O e-mail de receita das marcas (pedido
 * recipe-<marca>) aponta para cá; o fluxo Cannect continua em /receitas.
 */
function BaseRecipeBranded() {
  const { config } = useBrand()

  const themeClass = config.scheduling.themeClass ?? ''

  return (
    <>
      <SEO
        title={`Receita ${config.name}`}
        description={`Acesse a sua receita ${config.name}.`}
        canonical={`${config.pathPrefix}/receitas`}
      />
      <div className={themeClass}>
        <BaseRecipe />
      </div>
    </>
  )
}

export default BaseRecipeBranded
